import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "i892248267__Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 765.7 406.4"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(".i892248267__st0{fill:none;stroke:#000;stroke-width:7.5}.i892248267__st1{enable-background:new}", -1)
      ]))]),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M758.4 222.7 3.8 378.4M765.5 359.3 5.3 402.7M1.3 354.8 741.7 85.9",
      class: "i892248267__st0"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M666.3 179c-2.4-11.4-1-21.9 4.2-31.3s12.5-15.1 22-17c9.3-1.9 18.2.4 26.7 7s13.9 15.6 16.3 27c2.4 11.6.9 22-4.4 31.2s-12.6 14.7-21.9 16.6-18.2-.3-26.7-6.7c-8.4-6.3-13.8-15.3-16.2-26.8m12.1-28.6c-3.7 7-4.5 15.3-2.5 25q3 14.55 12 23.4c6 5.9 12.6 8.1 19.9 6.6 7-1.5 12.2-6.1 15.5-13.8s3.9-16.5 1.9-26.4c-2-9.7-6.1-17-12.2-22q-9.15-7.5-19.2-5.4c-6.6 1.4-11.7 5.6-15.4 12.6M653.8 266.9l9.8-.6 15.7 45.2c4.2 12.6 6.6 20.7 7.2 24.2.1-3.3 1.6-11.7 4.4-25.2l10.4-46.4 9.5-.5 16.3 45.4 3.9 12.1 2.8 8.7.6 3.1c0-2.5 1.5-10.9 4.4-25.1l10.1-46.5 8.1-.5-18.4 79.7-9.8.6-14.5-41c-4.5-15.1-7.1-24.6-7.9-28.4 0 1.7-.5 4.7-1.4 9.2s-1.7 8.5-2.5 12.2-1.2 5.6-1.2 5.8l-10.7 44.4-9.4.5zM659.4 93.7l-26.8-73.8 13.3-4.8L696 62.4l7.2 7-24-66.4 8.3-3 26.8 73.8-13.3 4.8-50.1-47.3-7.2-7 24.1 66.4z",
      class: "i892248267__st1"
    }, null, -1))
  ]))
}
export default { render: render }